export const getStatus = (isFetching, isError) => {
  if (isFetching) {
    return "loading";
  }
  return isError ? "error" : "finished";
};
